export class Config {
  public static localhost = 'https://localhost:44339';
  public static connectapi = 'https://connectapi.expertapps.com.sa';
  public static connectSRapi = 'https://connectslr.expertapps.com.sa';

  // https://connectcore.expertapps.com.sa/
  public static coreUrl = 'https://connectcoreapi.expertapps.com.sa';
  public static coreSRUrl = 'https://connectcoreslr.expertapps.com.sa';

  // https://connectcoretest.expertapps.com.sa
  public static connectcoretestapi = 'https://connectcoretestapi.expertapps.com.sa';
  public static connectcoretestslr = 'https://connectcoretestslr.expertapps.com.sa';

  // https://connecttest.expertapps.com.sa
  public static connecttestapi = 'https://connecttestapi.expertapps.com.sa';
  public static connecttestslr = 'https://connecttestslr.expertapps.com.sa';

  // https://Connectreg.expertapps.com.sa
  public static connectregapi = 'https://Connectregapi.expertapps.com.sa';
  public static connectregslr = 'https://Connectregslr.expertapps.com.sa';

  ///////////////////////////////////////////////////////

  // https://connect.inndeve.com/
  // public static publishUrl = 'https://connectapi.inndeve.com';
  // public static publishSRUrl = 'https://connectapi.inndeve.com/slr';
  // public static signalR = 'https://slr.inndeve.com';

  // Test publish
  //  public static publishUrl = 'https://concurelcpabetest.inndeve.com'
  //  public static publishSRUrl = 'https://concurelcpaslrtest.inndeve.com';

  // https://camp.cpa.sa/ production
  public static publishUrl = 'https://campapi.cpa.sa';
  public static publishSRUrl = 'https://campslr.cpa.sa';

  // Test
  // public static publishUrl = 'https://concurelcpabetest.inndeve.com';
  // public static publishSRUrl = 'https://concurelcpaslrtest.inndeve.com';


  ///////////////////////////////////////////////////////

  // https://ConnectPFE.inndeve.com
  // public static connectPanelApi = 'https://ConnectPanelAPI.inndeve.com';
  // public static connectPanelSlr = 'https://ConnectNotificationAPI.inndeve.com';

  // https://concurelcpa.inndeve.com Dev
  public static concurelcpabeApi = 'https://concurelcpabe.inndeve.com';
  public static concurelcpabelSlr = 'https://concurelcpaslr.inndeve.com';


  // Test
  // public static concurelcpabeApi = 'https://concurelcpabetest.inndeve.com';
  // public static concurelcpabelSlr = 'https://concurelcpaslrtest.inndeve.com';


  // --------------------------------------------------------------------------------------------------//

  public static version = '0.0.2';

  public static currentEnv = Config.concurelcpabeApi;
  public static signalRUrl = Config.concurelcpabelSlr + '/hubs';

  public static originUrl = location.origin;
  public static baseUrl = Config.currentEnv;

  public static loginUrl = Config.baseUrl + '/api/Authenticate/login';
  public static apiUrl = Config.baseUrl + '/api';


  public static googleApiKey = 'AIzaSyBdScej8zNyAjz4YQuoWeo0jTfYv56pFc4';
  public static googleSiteKey = '6LeIGsocAAAAAAgHB8An7QMb99naC8cdTXL0qi-t';

  public static spportEmail = 'info@inndeve.com';
  public static NoOfHoursToEndMeeting = 2;
}
